<template>
  <el-dialog title="全部文件" :visible.sync="showDialog.dialogVisible" width="1000px">
    <el-button type="primary" @click="multiDownload">批量下载</el-button>
    <el-table :data="list" style="width: 100%" @selection-change="handleSelectionChange" v-loading="loading">
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="序号" type="index" width="70"></el-table-column>
      <el-table-column prop="name" label="文件名"></el-table-column>
      <el-table-column prop="createdAt" label="上传时间"></el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.current"
      :limit.sync="listQuery.size"
      @pagination="getList"
    />
  </el-dialog>
</template>

<script>
import { getFileList } from '@/api/common.js'
import ListUtils from '@/mixins/list-utils'
import { getArrIds } from '@/utils/index.js'
export default {
  name: 'OrderFileList',
  mixins: [ListUtils],
  props: {
    showDialog: {
      type: Object,
      default: () => {
        return {
          dialogVisible: false,
          id: ''
        }
      }
    }
  },
  data() {
    return {
      list: [
        {
          id: '111', // id
          name: 'xxx数据.stl', // 文件名
          createdAt: '2022-12-11 11:11:11' // 上传时间
        }
      ],
      multipleSelection: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      getFileList({ ...this.listQuery, id: this.showDialog.id }).then((res) => {
        const { rows, total } = res.data
        this.list = rows
        this.total = total
      }).finally(() => {
        this.loading = false
      })
    },
    // 批量下载
    multiDownload() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请先勾选下载文件')
      } else {
        const orderIds = getArrIds(this.multipleSelection)
        window.location.href = `/api/file/download?ids=${orderIds}`
        // window.open(`/api/file/download?ids=${orderIds}`)
      }
    },
    // 选择文件
    handleSelectionChange(val) {
      this.multipleSelection = val
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  .el-button {
    margin-bottom: 12px;
  }
}
</style>
